import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class channelsPlaylistsView_template extends vnTemplate {
    static CHANNEL_INFO_TAB = "info";
    static CHANNEL_PLAYLIST_TAB = "playlists";

    protected getTemplateHtml(): string {
        return /*html*/ `
            <div class="form-header">
                <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                <button data-bind="event: { click: onClickEdit   }" class="btn icon i-edit" type="button">Edit Playlist</button>
            </div>

            <div class="form-pagination">
                <button data-bind="event: { click: onClickSelectTab.bind($data, '${channelsPlaylistsView_template.CHANNEL_INFO_TAB}') }, css: { 'is-activated': selectedTab() == '${channelsPlaylistsView_template.CHANNEL_INFO_TAB}' }" class="btn icon i-playlist" type="button"><span class="btn-text">Playlist</span></button>
                <button data-bind="event: { click: onClickSelectTab.bind($data, '${channelsPlaylistsView_template.CHANNEL_PLAYLIST_TAB}') }, css: { 'is-activated': selectedTab() == '${channelsPlaylistsView_template.CHANNEL_PLAYLIST_TAB}' }" class="btn icon i-video-2" type="button"><span class="btn-text" data-bind="text: 'Videos' + (articles().length ? ' (' + articles().length + ')' : '')"></span></button>
            </div>

            <div class="ww-form-body" data-bind="css: { 'is-showing': selectedTab() == '${channelsPlaylistsView_template.CHANNEL_INFO_TAB}' }">
                <div class="form-body">
                    <strong class="form-sub-title">Playlist</strong>
                    <div class="form-group">
                        <dl class="double-list">
                            <dt><span>Title</span></dt>
                            <dd><span data-bind="text: title"></span></dd>

                            <dt><span>Description</span></dt>
                            <dd><span data-bind="text: description"></span></dd>

                            <dt><span>Channel</span></dt>
                            <dd><span data-bind="text: channelName"></span></dd>

                            <dt><span>Available for use</span></dt>
                            <dd><span style="text-transform: none" data-bind="text: isAvailableForUse() ? 'Yes' :'No'"></span></dd>

                            <dt><span>Date Created</span></dt>
                            <dd><span style="text-transform: none" data-bind="text: dateCreated"></span></dd>

                            <dt><span>Date Updated</span></dt>
                            <dd><span style="text-transform: none" data-bind="text: dateUpdated"></span></dd>

                            <dt class="full-width"><span>Image</span></dt>
                            <dd class="full-width"><img style="width:400px" data-bind="attr: { src: image }"  alt="" /></dd>
                        </dl>
                    </div>
                </div>
            </div>

            <div class="ww-form-body" data-bind="css: { 'is-showing': selectedTab() == '${channelsPlaylistsView_template.CHANNEL_PLAYLIST_TAB}' }">
                <div class="form-body">
                    <strong class="form-sub-title">Video Articles</strong>
                    <div class="form-group">
                        <dl class="">
                            <dt data-bind="css: { 'full-width': articles().length }">
                                <span>Video Articles</span>
                            </dt>
                            <!-- ko foreach: articles -->
                                <dd class="full-width articles-list">
                                    <a data-bind="click: $parent.onClickArticle.bind($data)" class="w-list">
                                        <span class="title" data-bind="text: $data.title"></span>
                                        <div>
                                            <span>ID: </span><span data-bind="text: $data.id"></span>
                                        </div>
                                        <div>
                                            <span>Last Published: </span><span data-bind="text: $data.dateMostRecentPublishedStatus ? $parent.formatDate($data.dateMostRecentPublishedStatus) : 'Never Published'"></span>
                                        </div>
                                    </a>
                                </dd>
                            <!-- /ko -->
                            <!-- ko ifnot: articles().length -->
                                <dd><span>No Videos</span></dd>
                            <!-- /ko -->
                        </dl>
                    </div>
                </div>
            </div>
        `;
    }

    protected getTemplateName(): string {
        return "channelsPlaylistsView_template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "view-tag", "w-form-large"];
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected initPartial(): void {}

    protected buildViewModel(): any {
        let self = this;

        return {
            brand: ko.observable(""),
            channelName: ko.observable(""),
            dateCreated: ko.observable(null),
            dateUpdated: ko.observable(null),
            description: ko.observable(""),
            id: ko.observable(null),
            idChannel: ko.observable(null),
            image: ko.observable(""),
            isAvailableForUse: ko.observable(null),
            title: ko.observable(""),
            articles: ko.observableArray([]),
            selectedTab: ko.observable(channelsPlaylistsView_template.CHANNEL_INFO_TAB),

            formatDate: this.formatDate.bind(this),
            onClickArticle: this.onClickArticle.bind(this),
            onClickSelectTab: this.onClickSelectTab.bind(this),
            onClickEdit: (data) => {
                self.onClickEdit();
            },
            onClickCancel: (data, event) => {
                self.onClickCancel();
            },
        };
    }

    public setBrand(brand): void {
        this.getTemplateViewModel().brand(brand);
    }

    public onClickEdit() {
        this.caller.edit(this.getTemplateViewModel().id());
    }

    protected onClickCancel() {
        this.caller.cancel();
    }

    public setPlaylist(data): void {
        this.getTemplateViewModel().channelName(data.channelName);
        this.getTemplateViewModel().dateCreated(data.dateCreated);
        this.getTemplateViewModel().dateUpdated(data.dateUpdated);
        this.getTemplateViewModel().description(data.description);
        this.getTemplateViewModel().id(data.id);
        this.getTemplateViewModel().idChannel(data.idChannel);
        this.getTemplateViewModel().isAvailableForUse(data.availableForUse);
        this.getTemplateViewModel().title(data.title);
        if (data.image) {
            this.getTemplateViewModel().image(data.image.url);
        }
        this.getTemplateViewModel().articles((data.articles || []).sort((a, b) => a.position - b.position));
    }

    public onClickArticle(article) {
        this.caller.showArticle(article);
    }

    private formatDate(dateMostRecentPublishedStatus) {
        const date = new Date(dateMostRecentPublishedStatus);
        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    }

    private onClickSelectTab(tab) {
        this.getTemplateViewModel().selectedTab(tab);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/channelsPlaylistsView_template.ts